import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Input from '@material-ui/core/Input';

import style from './style';

const FilterInput = ({
  classes, filter, onChange, placeholder, 'data-testid': dataTestId,
}) => (
  <Input
    classes={{
      underline: classes.underline,
    }}
    inputProps={{
      'aria-label' : placeholder,
      onChange     : event => onChange(event.target.value),
      'data-testid': dataTestId,
    }}
    placeholder={placeholder}
    value={filter && filter.value}
  />
);
FilterInput.propTypes = {
  classes: PropTypes.shape({
    underline: PropTypes.shape({}),
  }).isRequired,
  filter: PropTypes.shape({
    value: PropTypes.oneOf(PropTypes.string, PropTypes.number),
  }),
  onChange     : PropTypes.func,
  placeholder  : PropTypes.string,
  'data-testid': PropTypes.string,
};
FilterInput.defaultProps = {
  filter: {
    value: '',
  },
  onChange() {},
  placeholder  : '',
  'data-testid': undefined,
};

export default withStyles(style)(FilterInput);
